/**
 * VendorPortalProductAddOnCategoryService
 * Service for vendor product add-on category management.
 * Route: api/vendor-portal/add-on-categories
 */
import { VendorPortalBaseService } from './VendorPortalBaseService';
/**
 * VendorPortalProductAddOnCategoryService
 * Handles vendor product add-on category operations for the vendor portal.
 * Maps to /api/vendor-portal/add-on-categories endpoint
 */
export class VendorPortalProductAddOnCategoryService extends VendorPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorPortalProductAddOnCategoryService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? VendorPortalProductAddOnCategoryService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET ALL ====================
    /**
     * Get all add-on categories for the authenticated vendor
     * GET /api/vendor-portal/add-on-categories
     */
    async getCategories() {
        const response = await this.getCategoriesRaw();
        return response.data ?? [];
    }
    /**
     * Get all categories (raw response)
     */
    getCategoriesRaw() {
        return this.get();
    }
    // ==================== GET BY ID ====================
    /**
     * Get a specific category by ID
     * GET /api/vendor-portal/add-on-categories/{id}
     */
    async getCategory(id) {
        const response = await this.getCategoryRaw(id);
        if (!response.data) {
            throw new Error(`Add-on category with ID ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get a specific category (raw response)
     */
    getCategoryRaw(id) {
        return this.get(`${id}`);
    }
    // ==================== CREATE ====================
    /**
     * Create a new add-on category
     * POST /api/vendor-portal/add-on-categories
     */
    async createCategory(data) {
        const response = await this.createCategoryRaw(data);
        if (!response.data) {
            throw new Error('Failed to create add-on category');
        }
        return response.data;
    }
    /**
     * Create a new category (raw response)
     */
    createCategoryRaw(data) {
        return this.post('', data);
    }
    // ==================== UPDATE ====================
    /**
     * Update an existing add-on category
     * PUT /api/vendor-portal/add-on-categories/{id}
     */
    async updateCategory(id, data) {
        const response = await this.updateCategoryRaw(id, data);
        if (!response.data) {
            throw new Error(`Failed to update add-on category with ID ${id}`);
        }
        return response.data;
    }
    /**
     * Update an existing category (raw response)
     */
    updateCategoryRaw(id, data) {
        return this.put(`${id}`, data);
    }
    // ==================== DELETE ====================
    /**
     * Delete an add-on category
     * DELETE /api/vendor-portal/add-on-categories/{id}
     */
    async deleteCategory(id) {
        const response = await this.deleteCategoryRaw(id);
        return response.success;
    }
    /**
     * Delete a category (raw response)
     */
    deleteCategoryRaw(id) {
        return this.delete(`${id}`);
    }
}
VendorPortalProductAddOnCategoryService.DEFAULT_SERVICE_PATH = 'vendor-catalogs';
VendorPortalProductAddOnCategoryService.BASE_PATH = 'api/vendor-portal/add-on-categories';
//# sourceMappingURL=VendorPortalProductAddOnCategoryService.js.map